import classNames from 'classnames';
import type React from 'react';

import './Spinner.scss';

type SpinnerProps = {
  className?: string;
  children?: React.ReactNode;
};

export const Spinner = ({ children, className, ...rest }: SpinnerProps) => {
  const spinnerClassName = className
    ? classNames('Spinner', { [className]: !!className })
    : classNames('Spinner', {});
  return (
    <div data-testid="spinner" className={spinnerClassName} {...rest}>
      {children}
    </div>
  );
};
